import React,{Component} from 'react';

class MoneyDisplay extends Component {
  render(){
    if(isNaN(parseFloat(this.props.children))){
      return (
        <span></span>
      );
    } else {
      return (
        <span>${parseFloat(this.props.children).toLocaleString('en-US',{currency:'USD',minimumFractionDigits:2})}</span>
      );
    }
  }
}

export default MoneyDisplay;



// WEBPACK FOOTER //
// ./src/shared/components/MoneyDisplay/index.js